// PAQUETES
import {useNavigate, useLocation} from 'react-router-dom';
import React, {useState, useEffect} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../paginas/alertas/zonaCargando';
import ToggleTema from '../componentesEspeciales/toggleTema';
// Estilos
import '../estilos/headerGlobal.css';



function CabeceraUsuarioVendedor({ usuario, cargandoUsuario, setUsuario }){

    const navigate = useNavigate();
    const location = useLocation();
    const [cargando, setCargando] = useState(false);
    const [hayNotificacionesNoLeidas, setHayNotificacionesNoLeidas] = useState(false);
    const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando); // controla cargando de usuario direccionamiento, y cargando local
    const esComprador = usuario?.modo === "Comprador";
    const colorModo = esComprador ? "var(--azul-logo-claro)" : "var(--naranja-cta)";
    const usuarioVerificado =  usuario?.verificacionIdentidad?.estado === "aprobado";


    useEffect(() => {
    async function obtenerNotificacionesNoLeidas() {
        try {
            if (!usuario?.idUsuario) {
                setHayNotificacionesNoLeidas(false);
                return;
            }

            const resNotificaciones = await axios.post("/notificaciones/contar-no-leidas", {
                params: { idUsuario: usuario.idUsuario, rolDestino: "Vendedor" }
            });

            setHayNotificacionesNoLeidas(Number(resNotificaciones?.data?.noLeidas || 0) > 0);
        } catch (err) {
            console.log("error obteniendo notificaciones no leídas:", err);
            setHayNotificacionesNoLeidas(false);
        }
    }

    obtenerNotificacionesNoLeidas();
}, [usuario?.idUsuario, location.pathname]);


    function cerrarSesion(event) {
        // evita el parpadeo predefinido
        event.preventDefault();
        setCargando(true);
    
        localStorage.clear(); // Limpiamos el almacenamiento local.
        axios.post("/cerrar-sesion")
            .then(function(response) {
                setCargando(false);
                //console.log(response);
                if (typeof setUsuario === "function") setUsuario(null); // aseguramos que setUsuario exista para ponerlo en null.
                navigate("/"); // Redirige a la página principal
            })
            .catch(function(error) { console.error("Error al cerrar sesión:", error); });
    }


    async function cambiarModo(){
        if (!usuario) return;
        setCargando(true);

        try{
            const response = await axios.post("/cambiar-modo", { params: {usuario: usuario.username, modoActual: usuario.modo }});
            setCargando(false);

            if(response.status===200){
                //console.log("modo cambiado correctamente, nuevoModo: ", response.data.nuevoModo);
                // ✅ Actualizar usuario en memoria para reflejar el cambio inmediatamente (sin refrescar)
                const nuevoModo = response.data.nuevoModo;
                if (typeof setUsuario === "function") {
                    setUsuario((prev) => {
                        const base = (prev && typeof prev === 'object') ? prev : usuario;
                        return { ...(base || {}), modo: nuevoModo };
                    });
                }
                
                Swal.fire({
                icon: 'success',
                title: "Éxito",
                text: "Modo cambiado correctamente.",
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
                showCancelButton: false,
                confirmButtonText: 'Continuar'
                }).then((result) => {
                if (result.isConfirmed) {
                    nuevoModo === "Comprador" ? navigate("/") : navigate("/vendedor");
                }
                });
            }

        }
        catch(err){
            setCargando(false);
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error cambiando el modo. Vuelva a intentar",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
            });
        }
    };






    return ( 
    <div>
    { (cargandoFinal) ? <ZonaCargando />
    :  <header className="py-3 mb-1 border-bottom" style={{backgroundColor: "var(--gris-900)"}} >
            <div className="container">
                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-between">
                    {/* logo */}
                    <a href="/vendedor" className="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none">
                        <img src="/imagenes/marca/zervicyblancohorizontal.png" alt="Logo" width="200" height="40" />
                    </a>
                    {/* Menú */}
                    <ul className="nav d-none d-lg-flex col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                        <li><a href="/vendedor/servicios" className="nav-link px-2 text-light">Mis servicios</a></li>
                        <li><a href="/vendedor/preguntas" className="nav-link px-2 text-light">Preguntas</a></li>
                        <li><a href="/vendedor/crear-editar-servicio" className="nav-link px-2 text-light">Crear servicio</a></li>
                        <li><a href="/vendedor/gestionar-reservas" className="nav-link px-2 text-light">Reservas</a></li>
                        <li><a href="/vendedor/agenda" className="nav-link px-2 text-light">Agenda</a></li>
                        <li><a href="/vendedor/gestionar-pagos" className="nav-link px-2 text-light">Pagos</a></li>
                    </ul>


                    {/* MODO:  MUESTRA EN PC, OCULTO EN CELULARES*/}
                    {!usuario ? null
                    :<li className="d-none d-lg-flex align-items-center mx-3">
                        <div className="form-check form-switch mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switchCheckDefault"
                                checked={esComprador}
                                onChange={cambiarModo}
                                style={{
                                    backgroundColor: colorModo,
                                    borderColor: colorModo
                                }}
                            />
                            <label className="form-check-label text-light" htmlFor="switchCheckDefault">{usuario.modo}</label>
                        </div>
                    </li>
                    }


                    {/* MODO OSCURO: MUESTRA EN PC, OCULTO EN CELULARES */}
                    <div className="d-none d-lg-flex align-items-center ms-3">
                        <ToggleTema />
                    </div>

                    {/* NOTIFICACIONES: MUESTRA EN PC, OCULTO EN CELUALRES */}
                    <div className="d-none d-lg-flex align-items-center ms-3 me-4">
                        <a href="/vendedor/notificaciones" className="text-light" title="Notificaciones" style={{ lineHeight: 1 }}>
                            <div style={{ position: "relative", display: "inline-block" }}>
                                <i className="bi bi-bell-fill" style={{ fontSize: 22, opacity: 0.9 }}></i>

                                {!hayNotificacionesNoLeidas ? null : (
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: -2,
                                            right: -4,
                                            width: 10,
                                            height: 10,
                                            backgroundColor: "var(--azul-logo-claro)",
                                            borderRadius: "50%",
                                            border: "2px solid white"
                                        }}
                                    ></span>
                                )}
                            </div>
                        </a>
                    </div>

                    
                    
                    
                   

                    {/* AVATAR Y MENU: MUESTRA EN PC, OCULTO EN CELULARES */}
                    <div className="d-none d-lg-flex dropdown text-end">
                        {/* Icono */}
                        <button
                            type="button"
                            className="btn dropdown-toggle p-0 border-0 bg-transparent position-relative"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <img
                                src={usuario.avatar}
                                alt="Avatar"
                                width="40"
                                height="40"
                                className="rounded-circle"
                            />

                            <img
                                src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/iconos/autenticado.svg"
                                alt="Verificado"
                                width="18"
                                height="18"
                                style={{
                                    position: "absolute",
                                    top: -2,
                                    left: -2,
                                    filter: usuarioVerificado
                                    ? "brightness(0) saturate(100%) invert(72%) sepia(31%) saturate(873%) hue-rotate(100deg) brightness(89%) contrast(87%)"
                                    : "brightness(0) invert(1) opacity(0.9)",
                                }}
                            />
                        </button>
                        <ul className="dropdown-menu text-small">
                            <li><a className="dropdown-item" href="/vendedor">Dashboard</a></li>
                            <li><a className="dropdown-item" href="/vendedor/servicios">Mis servicios</a></li>
                            <li><a className="dropdown-item" href="/vendedor/preguntas">Preguntas</a></li>
                            <li><a className="dropdown-item" href="/vendedor/crear-editar-servicio">Crear servicio</a></li>
                            <li><a className="dropdown-item" href="/vendedor/gestionar-reservas">Reservas</a></li>
                            <li><a className="dropdown-item" href="/vendedor/agenda">Agenda</a></li>
                            <li><a className="dropdown-item" href="/vendedor/gestionar-pagos">Pagos</a></li>
                            <li> <hr className="dropdown-divider" /> </li>
                            <li><a className="dropdown-item" href="/vendedor/mi-cuenta">Mi cuenta</a></li>
                            <li><button onClick={cerrarSesion} className="dropdown-item" type="button">Cerrar Sesión</button></li>
                        </ul>
                    </div>




                    {/* MENÚ EN CELULARES: OCULTO EN PANTALLAS, MUESTRA EN CELUALRES */}
                    <button className="btn btn-primary d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop"> <i className="bi bi-list"></i> </button>
                    <div className="offcanvas offcanvas-end" data-bs-backdrop="static" tabIndex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
                        {/* cabecera */}
                        <div className="offcanvas-header border-bottom border-1 border-dark">
                            {/* Logo */}
                            <a href="/vendedor" className="d-flex align-items-center  text-white text-decoration-none"  >
                                <img src="/imagenes/marca/zervicyazulhorizontal.png" alt="Logo" width="200" height="40" className="logo-offcanvas-claro" />
                                <img src="/imagenes/marca/zervicyblancohorizontal.png" alt="Logo" width="200" height="40" className="logo-offcanvas-oscuro" />
                            </a>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        
                        {/* cuerpo */}
                        {usuario ?
                        <div className="offcanvas-body">
                            {/* Íconos horizontales */}
                            <ul className="nav justify-content-around mb-4">
                                {/* modo oscuro */}
                                <li className="nav-item d-flex align-items-center">
                                    <ToggleTema sobreFondoOscuro={false} />
                                </li>
                                {/* notificaciones */}
                                <li className="nav-item">
                                    <a href="/vendedor/notificaciones" className="nav-link text-dark" title="Notificaciones">
                                        <div style={{ position: "relative", display: "inline-block" }}>
                                            <i className="bi bi-bell-fill"></i>

                                            {!hayNotificacionesNoLeidas ? null : (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: -4,
                                                        right: -4,
                                                        width: 10,
                                                        height: 10,
                                                        backgroundColor: "var(--azul-logo-claro)",
                                                        borderRadius: "50%",
                                                        border: "2px solid white"
                                                    }}
                                                ></span>
                                            )}
                                        </div>
                                    </a>
                                </li>
                                {/* mensajes */}
                                {/* <li className="nav-item">
                                    <a href="/mis-mensajes" className="nav-link text-dark" title="Mensajes">
                                    <i className="bi bi-envelope-paper-fill"></i>
                                    </a>
                                </li> */}
                                {/* favoritos */}
                                {/* <li className="nav-item">
                                    <a href="/mis-favoritos" className="nav-link text-dark" title="Favoritos">
                                    <i className="bi bi-heart-fill"></i>
                                    </a>
                                </li> */}
                                {/* modo de usuario */}
                                <li className="nav-item d-flex align-items-center">
                                    <div className="form-check form-switch">
                                        <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="switchCheckDefault"
                                        checked={esComprador}
                                        onChange={cambiarModo}
                                        style={{
                                            backgroundColor: colorModo,
                                            borderColor: colorModo
                                        }}
                                        />
                                        <label className="form-check-label ms-2" htmlFor="switchCheckDefault">{usuario.modo}</label>
                                    </div>
                                </li>
                            </ul>

                            {/* Opciones verticales */}
                            <ul className="nav flex-column">
                                <li className="nav-item mb-1"><a href="/vendedor/servicios" className="nav-link text-dark">Servicios</a></li>
                                <li className="nav-item mb-1"><a href="/vendedor/preguntas" className="nav-link text-dark">Preguntas</a></li>
                                <li className="nav-item mb-1"><a href="/vendedor/crear-editar-servicio" className="nav-link text-dark">Crear servicio</a></li>
                                <li className="nav-item mb-1"><a href="/vendedor/gestionar-reservas" className="nav-link text-dark">Reservas</a></li>
                                <li className="nav-item mb-1"><a href="/vendedor/agenda" className="nav-link text-dark">Agenda</a></li>
                                <li className="nav-item mb-1"><a href="/vendedor/gestionar-pagos" className="nav-link text-dark">Pagos</a></li>
                                <li className="nav-item mb-1 pt-2  border-top border-1 border-dark mt-3"><a href="/vendedor/mi-cuenta" className="nav-link text-dark">Mi cuenta</a></li>
                                <li className="nav-item mb-1">
                                    <button onClick={cerrarSesion} className="nav-link text-dark btn btn-link text-start text-decoration-none">Cerrar sesión</button>
                                </li>
                                
                            </ul>

                        </div>
                        :<div className="offcanvas-body">
                              <ul className="nav flex-column">
                                <li className="nav-item mb-2"><a href="/iniciar-sesion" className="nav-link text-dark">Iniciar Sesión</a></li>
                            </ul>
                        </div>  
                        }
                    </div>

                    
                </div>
            </div>
    </header>
    }
    </div>
    )
}


export default CabeceraUsuarioVendedor;